import { render } from "./probaworkflows_layout.html?vue&type=template&id=2819c770&external"
import script from "./probaworkflows_layout.js?vue&type=script&lang=js&external"
export * from "./probaworkflows_layout.js?vue&type=script&lang=js&external"

import "./probaworkflows_layout.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__